import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { request } from './client.ts';
import { qk } from './keys.ts';
import type {
  AdminOrgListItem,
  AdminCreateOrg as CreateAdminOrg,
  CreateAdminOrgResult,
  AdminUpdateOrg as UpdateAdminOrg,
} from '@seencast/shared';
import type { ListEnvelope } from './client.ts';

export function listAdminOrgs(): Promise<AdminOrgListItem[]> {
  return request<ListEnvelope<AdminOrgListItem>>('/admin/orgs').then((r) => r.items);
}

export function useAdminOrgs() {
  return useQuery({ queryKey: qk.adminOrgs, queryFn: listAdminOrgs });
}

export function useCreateAdminOrg() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateAdminOrg) =>
      request<CreateAdminOrgResult>('/admin/orgs', { method: 'POST', body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.adminOrgs }),
  });
}

export function useUpdateAdminOrg() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateAdminOrg }) =>
      request<AdminOrgListItem>(`/admin/orgs/${id}`, { method: 'PATCH', body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.adminOrgs }),
  });
}
